// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2yzBY","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1jhY1"};